import React from 'react'
import FunctionCategorySelect from '../FunctionCategorySelect'
import { NodeContentProps, NodesById } from '../../types'
import { NormalizedResetVisitor } from '../../normalizedVisitors/NormalizedResetVisitor'

// Laajennettu props-tyyppi normalisoitua dataa varten
interface ExtendedNodeContentProps extends NodeContentProps {
  nodesById: NodesById
}

const FunctionNodeContent: React.FC<ExtendedNodeContentProps> = ({ node, rules, onUpdateValue, nodesById }) => {
  const onValuesChange = (value: string) => {
    // Päivitetään ensin tämän solmun arvo
    onUpdateValue(node.id, { value })

    // Luodaan NormalizedResetVisitor, joka resetoi funktion lapset
    const visitor = new NormalizedResetVisitor(
      rules,
      nodesById,
      { type: node.type, value },
      // Välitetään onUpdateValue callback, jotta visitor voi päivittää solmuja
      onUpdateValue
    )

    // Aloitetaan vierailu tästä solmusta
    visitor.reset(node.id)
  }

  return (
    <FunctionCategorySelect
      value={node.value}
      onChange={onValuesChange}
      style={{ width: 200 }}
      data-cy={`function-select-${node.id}`}
    />
  )
}

export default FunctionNodeContent
